import { Component } from '@angular/core';

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss']
})
export class FeatureComponent {

public featureArr:any[]=[
  {
      "id": 1,
      "feature_name": "Course Builder",
      "feature": "course_builder",
      "description": "",
      "type": 0,
      "pri_30_m": 2,
      "pri_pu_m": 0.25,
      "pri_30_y": 1.5,
      "pri_pu_y": 0.15,
      "created_at": "2023-10-24 09:05:22"
  },
  {
      "id": 2,
      "feature_name": "Upload Document",
      "feature": "upload_document",
      "description": "",
      "type": 0,
      "pri_30_m": 2,
      "pri_pu_m": 0.25,
      "pri_30_y": 1.5,
      "pri_pu_y": 0.15,
      "created_at": "2023-10-24 09:10:15"
  },
  {
      "id": 3,
      "feature_name": "Upload Contract",
      "feature": "upload_contract",
      "description": "",
      "type": 0,
      "pri_30_m": 3,
      "pri_pu_m": 1,
      "pri_30_y": 2,
      "pri_pu_y": 0.25,
      "created_at": "2023-10-24 09:10:15"
  },
  {
      "id": 4,
      "feature_name": "Staff Suevey",
      "feature": "staff_survey",
      "description": "",
      "type": 0,
      "pri_30_m": 4,
      "pri_pu_m": 1.2,
      "pri_30_y": 3,
      "pri_pu_y": 0.25,
      "created_at": "2023-10-24 09:10:15"
  },
  {
      "id": 5,
      "feature_name": "Forum",
      "feature": "forum",
      "description": "",
      "type": 0,
      "pri_30_m": 5,
      "pri_pu_m": 4,
      "pri_30_y": 3,
      "pri_pu_y": 1,
      "created_at": "2023-10-24 09:10:15"
  },
  
]
  constructor(){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
   let selectedFeature=[4,5]
   let newArr:any[]= [...this.featureArr.filter(item=>selectedFeature.includes(item.id))]
  }
}
